import React, { useEffect, useState } from "react";
import { HeaderAddressMenuContent } from "../../header/header-buttons/addresses-button/styled";
import WarehouseAddressInfo from "../../header/header-buttons/addresses-button/address-menu-item";
import { useAppSelector } from "../../../redux/store";
import { SingleWarehouse } from "../../components/single-warehouse/single-warehouse";
import { WarehouseModel } from "../../shared/models/order/warehouse.model";
import Message from "../../components/message";
import { MessageSections } from "../../components/message/message";
import { AddressesContainer, AddressesContentContainer } from "./styled";
import { ActionBar } from "../../components/action-bar/action-bar";

export const Addresses = ({ size }: AddressesProps) => {
    const { countries } = useAppSelector(state => state.staticDataReducer);
    const [selectedWarehouse, setSelectedWarehouse] = useState<WarehouseModel>();
    const { matchesPhone } = useAppSelector(state => state.deviceReducer);

    useEffect(() => {
        const firstWarehouse = countries
            .find(country => !!country.warehouse.length)
            ?.warehouse[0]

        setSelectedWarehouse(firstWarehouse);
    }, [])

    const Content = () => (
        <HeaderAddressMenuContent style={{ flexDirection: matchesPhone ? 'column' : 'row' }}>
            <div>
                {countries.map(country =>
                    <>
                        {country && country.isAllowedExport && country?.hasActiveWarehouse ?
                            country.warehouse.map(warehouse =>
                                <SingleWarehouse
                                    key={warehouse.warehouseId}
                                    selected={selectedWarehouse && selectedWarehouse.warehouseId === warehouse.warehouseId}
                                    warehouse={warehouse}
                                    country={country}
                                    size={size}
                                    onChange={(warehouse: WarehouseModel) => setSelectedWarehouse(warehouse)} />
                            ) :
                            <></>}
                    </>
                )}
            </div>

            {selectedWarehouse
                ? <WarehouseAddressInfo warehouse={selectedWarehouse} />
                : ''
            }
        </HeaderAddressMenuContent>
    )

    if (size === 'm') {
        return (
            <AddressesContainer>
                <ActionBar headerText={<Message messageKey={'my_addresses_title'} sectionId={MessageSections.MAIN} />} />
                <AddressesContentContainer>
                    <Content />
                </AddressesContentContainer>
            </AddressesContainer>
        )
    } else {
        return <Content />
    }
}

interface AddressesProps {
    size: 's' | 'm'
}